export default __webpack_public_path__ + "static/media/newblp_History.bb8b73fe.svg";